import config from './config';
import { getIdToken } from './auth';

const apiCall = async (path, options = {}) => {
  const token = await getIdToken();

  const response = await fetch(`${config.api.baseUrl}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || 'Request failed');
  }

  return response.json();
};

// Notes API
export const listNotes = (limit = 20, lastKey = null) => {
  const params = new URLSearchParams({ limit });
  if (lastKey) params.append('lastKey', lastKey);
  return apiCall(`/notes?${params}`);
};

export const createNote = (content) => {
  return apiCall('/notes', {
    method: 'POST',
    body: JSON.stringify({ content }),
  });
};

export const getNote = (id) => {
  return apiCall(`/notes/${id}`);
};

export const deleteNote = (id) => {
  return apiCall(`/notes/${id}`, { method: 'DELETE' });
};

export const updateNoteExpiry = (id, expiry) => {
  return apiCall(`/notes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ expiry }),
  });
};

// Files API
export const listFiles = (limit = 20, lastKey = null) => {
  const params = new URLSearchParams({ limit });
  if (lastKey) params.append('lastKey', lastKey);
  return apiCall(`/files?${params}`);
};

export const getUploadUrl = (filename, contentType, size) => {
  return apiCall('/files/upload-url', {
    method: 'POST',
    body: JSON.stringify({ filename, contentType, size }),
  });
};

export const getDownloadUrl = (id) => {
  return apiCall(`/files/${id}/download-url`);
};

export const getViewUrl = (id) => {
  return apiCall(`/files/${id}/download-url?inline=true`);
};

export const deleteFile = (id) => {
  return apiCall(`/files/${id}`, { method: 'DELETE' });
};

export const updateFileExpiry = (id, expiry) => {
  return apiCall(`/files/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ expiry }),
  });
};

// Upload file to S3 using presigned URL
export const uploadFile = async (file) => {
  const contentType = file.type || 'application/octet-stream';
  const { id, uploadUrl } = await getUploadUrl(file.name, contentType, file.size);

  await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
    },
  });

  return id;
};
